import { createEventHandlerContext } from "~/hoc/EventContext";
const ctx = createEventHandlerContext();
export default ctx;